import { useQueryClient } from "react-query";
import useQueryBuilding from "ApiLayer/Building/queryBuildingModel";
import { resetBMCRPQueries } from "./invalidateBMCRPQueries";

export const useResetRecommendedBMCRPQueries = (buildingModelUid: string) => {
    const { data: buildingModel } = useQueryBuilding(buildingModelUid);
    const queryClient = useQueryClient();

    return () => {
        const reportedBMCRP = buildingModel?.carbonReductionPlans?.find(
            (bmcrp) => bmcrp.plan.carbonReductionPlanUid === buildingModel?.reportedCrp?.carbonReductionPlanUid
        );
        if (reportedBMCRP?.id) {
            resetBMCRPQueries(reportedBMCRP.id, queryClient);
        } else {
            console.warn("No recommended BMCRP found for reset.");
        }
    };
};
